/** @format */

const Footer = () => {
  return (
    <footer>
      <div className="footer-inner">
        <p><a target="_blank" rel="noopener noreferrer nofollow" href="https://ourrealsuccess.com/terms-of-conditions/">Terms &amp; Conditions </a>-  <a target="_blank" rel="noopener noreferrer nofollow" href="https://ourrealsuccess.com/privacy-policy/">Privacy Policy</a></p>
        
        <p>Copyright @ 2025. RealSuccess Investments.</p>
        
      </div>
    </footer>
  );
};

export default Footer;
